module.exports = __webpack_public_path__ + "img/info-4.6b0bd9f7.svg";